import { render, staticRenderFns } from "./addAchievement.vue?vue&type=template&id=6d4c8e3a&scoped=true"
import script from "./addAchievement.vue?vue&type=script&lang=js"
export * from "./addAchievement.vue?vue&type=script&lang=js"
import style0 from "./addAchievement.vue?vue&type=style&index=0&id=6d4c8e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c8e3a",
  null
  
)

export default component.exports